import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.widget.ticketing');
import { OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcuser-widget-ticketing',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.widget.ticketing/view.scss */
:host {
  display: block;
  min-width: 0;
  height: 100%;
}

.db-ticket-heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 3px 12px;
  min-width: 0;
}

.db-ticket-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 10px;
  color: var(--db-muted, #677b91);
  font-size: 12px;
}

.db-ticket-open {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
}

.db-ticket-open strong {
  color: var(--db-blue, #175d9c);
  font-size: 14px;
}

.db-ticket-loading, .db-ticket-error {
  padding: 24px 16px;
  color: var(--db-muted, #677b91);
  font-size: 13px;
  text-align: center;
}

.db-ticket-loading p, .db-ticket-error p {
  margin: 0 0 10px;
}

.db-ticket-retry {
  padding: 6px 12px;
  border: 1px solid var(--db-line, #e5ebf2);
  border-radius: 7px;
  background: var(--db-bg, #fff);
  color: var(--db-blue, #175d9c);
  font-size: 12px;
  cursor: pointer;
}

.db-ticket-retry:focus-visible {
  outline: 2px solid var(--db-blue, #175d9c);
  outline-offset: 2px;
}`],
})
export class PortalGsdcuserWidgetTicketingComponent implements OnInit, OnDestroy {
    @Output() contextChange = new EventEmitter<string | null>();
    public ticketing: any[] = [];
    public direction: string = '';
    public openCount = 0;
    public listPath = '/support/ticketing';
    public listQuery: any = {};
    public loading = true;
    public loadFailed = false;
    private requestPending = false;
    private destroyed = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.destroyed) return;
        await this.service.auth.allow(true, '/login');
        if (!this.destroyed) await this.load();
    }

    public ngOnDestroy() { this.destroyed = true; }

    public get title() {
        return this.direction === 'received' ? '받은 티켓' : this.direction === 'all' ? '전체 티켓' : this.direction === 'sent' ? '보낸 티켓' : '티켓팅';
    }

    public detailUrl(item: any) {
        return (this.direction === 'sent' ? '/support/ticketing/' : '/admin/ticketing/') + encodeURIComponent(String(item.id));
    }

    public unread(item: any) {
        if (this.direction === 'sent') return item.requester_confirm === 'N';
        return this.direction === 'received' && item.assignee_confirm === 'N'
            && String(item.assignee_id) === String(this.service.auth.session.id);
    }

    public async load() {
        if (this.requestPending || this.destroyed) return;
        this.requestPending = true;
        this.loading = true;
        this.loadFailed = false;
        try {
            await this.service.render();
            if (this.destroyed) return;
            const { code, data } = await wiz.call('load');
            if (this.destroyed) return;
            if (code !== 200 || !Array.isArray(data?.rows) || !['sent', 'received', 'all'].includes(data.direction)) throw new Error('load');
            const count = Number(data.open_count);
            if (!Number.isSafeInteger(count) || count < 0) throw new Error('count');
            this.direction = data.direction;
            this.ticketing = data.rows.slice(0, 3);
            this.openCount = count;
            this.listPath = this.direction === 'sent' ? '/support/ticketing' : '/admin/ticketing';
            this.listQuery = this.direction === 'sent' ? {} : { status: 'open' };
            this.contextChange.emit(['received', 'all'].includes(data.management_direction) ? data.management_direction : null);
        } catch (_) {
            if (this.destroyed) return;
            this.ticketing = [];
            this.loadFailed = true;
        } finally {
            this.loading = false;
            this.requestPending = false;
            if (!this.destroyed) await this.service.render();
        }
    }
}

export default PortalGsdcuserWidgetTicketingComponent;